<template>
  <page-table title="Overview of Wallets" subtitle=" " :total-rows="totalRows" :per-page.sync="perPage" :current-page.sync="currentPage">
    <template v-slot:table>
      <b-table tbody-tr-class="rowClass" striped :busy="busy" :items="wallets" :fields="fields" :current-page="currentPage" :per-page="perPage" :sort-by="sortBy" :sort-desc="sortDesc" :sort-direction="sortDirection">
        <template #cell(public_key)="data">
          <address-book-by-public-key :public-key="data.value" />
        </template>
        <template #cell(balance)="data">
          <b>{{ data.value | formatGRAM }}</b>
        </template>
        <template #cell(created_at)="data">
          {{ data.value | timestamp }}
        </template>
        <template #cell(action)="data">
          <toggle-switch :value="data.item.checked" @change="check($event, data.item)" />
        </template>
        <template #table-busy>
          <div class="text-center  my-5">
            <b-spinner class="align-middle" />
          </div>
        </template>
      </b-table>
    </template>
  </page-table>
</template>

<script>
import { mapGetters } from 'vuex'
import PageTable from '@/components/protected/PageTable.vue'
import AddressBookByPublicKey from '@/components/protected/common/AddressBookByPublicKey.vue'
import ToggleSwitch from '@/components/protected/common/ToggleSwitch.vue'

export default {
  name: 'Wallets',
  components: { AddressBookByPublicKey, ToggleSwitch, PageTable },
  data () {
    return {
      fields: [
        {
          key: 'public_key',
          label: 'Address',
          sortable: true
        },
        {
          key: 'balance',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'Created',
          sortable: true
        },
        {
          key: 'action'
        }
      ],
      wallets: [],
      busy: false,
      currentPage: 1,
      sortBy: 'name',
      sortDesc: false,
      sortDirection: 'asc',
      perPage: 5,
      totalRows: 0
    }
  },
  computed: {
    ...mapGetters(['publicKey'])
  },
  watch: {
    wallets (value) {
      this.totalRows = value.length
    }
  },
  mounted () {
    this.getWallets()
  },
  methods: {
    async getWallets () {
      try {
        this.busy = true
        this.wallets = (await this.$accounts.get('wallets')).data
        this.wallets.forEach(item => {
          item.balance = null
        })
        this.wallets.forEach(w => w.checked = (this.publicKey === w.public_key))
        for (const wallet of this.wallets) {
          const balanceReply = await this.$api.get('/account/balance/' + wallet.public_key)
          wallet.balance = balanceReply.data
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.busy = false
      }
    },
    async check (checked, wallet) {
      if (checked) {
        try {
          await this.$accounts.post('/users/default_wallet_id', {
            wallet: wallet.wallet_id
          })
          this.$store.commit('SET_ACTIVE_WALLET', { wallet_id: wallet.wallet_id, public_key: wallet.public_key })
          await this.getWallets()
          this.$toastr.s('Default Wallet set', 'Success')
        } catch (e) {
          console.error(e)
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
